import { animate } from 'animejs';
import globalVar from '../utils/globalVar';

class Module17Anchor {
  constructor() {
    let cache = {};
    let originalTop = 0;

    let initFunc = () => {
      initCache();
      if (!cache.module) return;
      fillEmptyLabels();
      registerEvents();
      updateSticky();
    }

    let initCache = () => {
      cache.module        = document.querySelector('.module-17-anchor');
      if (!cache.module) return;
      cache.links         = cache.module.querySelectorAll('.anchor-link');
      cache.header        = document.querySelector('header');
      cache.pageContainer = document.querySelector('.page-container');
    };

    let fillEmptyLabels = () => {
      cache.links.forEach(link => {
        if (link.textContent.trim()) return;
        const target = document.querySelector(link.getAttribute('href'));
        if (target && target.dataset.title) {
          link.textContent = target.dataset.title.replace(/<br\s*\/?>/gi, ' ').trim();
        }
      });
    };

    let rafId               = null;
    let headerTransitioning = false;

    let startHeaderLoop = () => {
      headerTransitioning = true;
      if (rafId) return;
      const tick = () => {
        updateSticky();
        if (headerTransitioning) {
          rafId = requestAnimationFrame(tick);
        } else {
          rafId = null;
        }
      };
      rafId = requestAnimationFrame(tick);
    };

    let registerEvents = () => {
      originalTop = cache.module.getBoundingClientRect().top + (window.scrollY || window.pageYOffset);

      // Placeholder permanently holds the module's space — layout never shifts
      const placeholder = document.createElement('div');
      // placeholder.style.height = cache.module.offsetHeight + 'px';
      placeholder.classList.add('module-17-anchor-placeholder');
      cache.module.parentNode.insertBefore(placeholder, cache.module);
      cache.placeholder = placeholder;

      // Module is always fixed — we only move its `top`, never toggle position type
      cache.module.style.position = 'fixed';
      cache.module.style.width = (cache.pageContainer
        ? cache.pageContainer.offsetWidth
        : window.innerWidth) + 'px';

      cache.links.forEach(link => {
        link.addEventListener('click', onAnchorClick);
      });

      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', onResize, { passive: true });

      // Follow header CSS transition (nav.js adds/removes .up on scroll)
      if (cache.header) {
        const observer = new MutationObserver(startHeaderLoop);
        observer.observe(cache.header, { attributes: true, attributeFilter: ['class'] });
        cache.header.addEventListener('transitionend', () => {
          headerTransitioning = false;
        });
      }
    };

    let onAnchorClick = function(e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (!target) return;
      const headerBottom = cache.header ? cache.header.getBoundingClientRect().bottom : 0;
      const targetTop    = globalVar.scrollElement.scrollTop + target.getBoundingClientRect().top - headerBottom;
      document.querySelector('body').classList.add('scroll');
      animate(globalVar.scrollElement, {
        scrollTop: targetTop,
        duration: 800,
        ease: 'inOutQuad',
        onComplete: function() {
          document.querySelector('body').classList.remove('scroll');
        }
      });
    };

    let onResize = () => {
      if (!cache.module.classList.contains('is-sticky') && !cache.module.classList.contains('is-sticky-bottom')) {
        originalTop = cache.placeholder.getBoundingClientRect().top + (window.scrollY || window.pageYOffset);
      }
      cache.placeholder.style.height = cache.module.offsetHeight + 'px';
      cache.module.style.width = (cache.pageContainer
        ? cache.pageContainer.offsetWidth
        : window.innerWidth) + 'px';
      updateSticky();
    };

    let updateSticky = () => {
      const scrollY         = window.scrollY || window.pageYOffset;
      const headerBottom    = cache.header ? cache.header.getBoundingClientRect().bottom : 0;
      const moduleHeight    = cache.module.offsetHeight;
      const containerBottom = cache.pageContainer
        ? cache.pageContainer.getBoundingClientRect().bottom
        : Infinity;

      let top;

      if (scrollY < originalTop - headerBottom) {
        // Not yet sticky — simulate natural scroll position
        top = originalTop - scrollY;
        cache.module.classList.remove('is-sticky', 'is-sticky-bottom');
        cache.header.classList.remove('has-sticky');
      } else if (headerBottom + moduleHeight >= containerBottom) {
        // Reached page-container bottom — anchor there
        top = containerBottom - moduleHeight;
        cache.module.classList.remove('is-sticky');
        cache.header.classList.remove('has-sticky');
        cache.module.classList.add('is-sticky-bottom');
      } else {
        // Sticky — follow header
        top = headerBottom;
        cache.module.classList.remove('is-sticky-bottom');
        cache.module.classList.add('is-sticky');
        cache.header.classList.add('has-sticky');
      }

      cache.module.style.top = top + 'px';
    };

    initFunc();
  };
}
export { Module17Anchor }
